module.exports = __webpack_public_path__ + "static/media/ad_bg.ba5a8139.png";